import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import DatePicker from "react-datepicker";
import {
    calculateDaysDifference, CompanyPermission,
    formatDateTimeToString, formatDateTimeNoSecondsToString,
    formatDateToAmericanFormat,
    formatDateToString, renderSaleOptions, SaleStatus, statusOptions, statusTranslate, UserPermission
} from "../../utils/utils";
import {
    companyHasPermission,
    downloadSaleFile,
    findSectorsByQueryString,
    getDefaultSaleSectors,
    getSaleById,
    updateSaleStatus
} from "../../utils/requestUtils";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import 'react-datepicker/dist/react-datepicker.css';
import ModalDiv from "../../ModalDiv";
import {useReactToPrint} from "react-to-print";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import NewButton from '../common/NewButton';
import ConfirmButton from '../common/ConfirmButton';
import SearchButton from '../common/SearchButton';
import TableRowActions from '../common/TableRowActions';
import WhatsAppButton from '../../core/WhatsAppButton';
import {buildDefaultWhatsAppMessage} from '../../utils/whatsappUtils';
import SaleViewer from "./SaleViewer";
import ListPageLayout from '../common/ListPageLayout';
import Loading from "../../core/Loading";
import {loadingAtom} from "../../atoms";
import loading from "../../core/Loading";
import {usePermission} from "../../core/PermissionContext";
import { showConfirm, showAlert } from '../../core/dialog';

const apiUrl = Config.apiUrl;
const SaleList = (props) => {
    const { hasUserPermission, hasCompanyPermission, loadingPermissions } = usePermission();
    const [sales, setSales] = useState([]);
    const [startDate, setStartDate] = useState(undefined);
    const [endDate, setEndDate] = useState(undefined);
    const [status, setStatus] = useState('IN_PROGRESS');
    const [totalValue, setTotalValue] = useState(0);
    const navigate = useNavigate();
    const [sectors, setSectors] = useState([]);
    const [selectedSectorIds, setSelectedSectorIds] = useState([]);
    const [sectorDropdownOpen, setSectorDropdownOpen] = useState(false);
    const sectorDropdownRef = useRef(null);
    const [saleShowFilesToDownload, setSaleShowFilesToDownload] = useState(undefined);
    const [saleShowPrintDialogIndex, setSaleShowPrintDialogIndex] = useState(undefined);
    const [saleIdToBeShowed, setSaleIdToBeShowed] = useState(undefined);
    const [searchTerm, setSearchTerm] = useState('');

    const componentRef = useRef();

    const [loading, setLoading] = useRecoilState(loadingAtom);

    async function makeQuery(sectorIdsOverride) {
        try {

            const newStartDate = startDate ? startDate : new Date(1900, 0, 1);
            const newEndDate = endDate ? endDate : new Date(2100, 0, 1);
            const effectiveSectorIds = sectorIdsOverride ?? selectedSectorIds;
            const effectiveAllSelected = sectors.length > 0 && effectiveSectorIds.length === sectors.length;
            const sectorParam = effectiveSectorIds.length > 0 && !effectiveAllSelected ? `&sectorIds=${effectiveSectorIds.join(',')}` : '';
            const url = `${apiUrl}/api/sales/queryByDateAndStatusAndSector?startDate=${formatDateToAmericanFormat(newStartDate)}&endDate=${formatDateToAmericanFormat(newEndDate)}&status=${status}${sectorParam}&searchTerm=${searchTerm}`;
            setLoading(true);
            const response = await makeRequest(url, 'GET');
            const updatedResponse = response.map(sale => ({
                ...sale,
                customerName: (sale.customerName ?? '').toString().toUpperCase(),
            }));
            setSales(updatedResponse);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        Promise.all([findSectorsByQueryString(""), getDefaultSaleSectors()])
            .then(([loadedSectors, defaultIds]) => {
                setSectors(loadedSectors);
                if (defaultIds.length > 0) {
                    setSelectedSectorIds(defaultIds);
                }
                makeQuery(defaultIds.length > 0 ? defaultIds : undefined);
            });
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (sectorDropdownRef.current && !sectorDropdownRef.current.contains(e.target)) {
                setSectorDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleSectorId = (id) => {
        setSelectedSectorIds(prev =>
            prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]
        );
    };

    const allSectorsSelected = sectors.length > 0 && selectedSectorIds.length === sectors.length;
    const sectorLabel = allSectorsSelected || selectedSectorIds.length === 0
        ? 'Todos'
        : selectedSectorIds.length === 1
            ? sectors.find(s => s.id === selectedSectorIds[0])?.name ?? '1 selecionado'
            : `${selectedSectorIds.length} selecionados`;

    useEffect(() => {
        setTotalValue(sales.reduce((acc, obj) => acc + obj.totalValue, 0));
    }, [sales]);

    async function removeSale(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/sales/' + id;
            await makeRequest(url, 'DELETE');
            await makeQuery();
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleQuery = async (e) => {
        await makeQuery();
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };

    const getSaleStatusStyle = (saleStatus) =>
        statusTranslate[saleStatus] || statusTranslate.IN_PROGRESS;

    const getSortValue = (item, key) => {
        if (key.includes('.')) {
            const [parent, child] = key.split('.');
            return item[parent]?.[child] ?? '';
        }
        if (key === 'value' || key === 'totalValue') {
            return item.totalValue ?? 0;
        }
        return item[key] ?? '';
    };

    function getWarningDeliveryDateColor(sale) {
        const currentDate = new Date();
const dueDate = new Date(sale.deliveryDate);
        const errorColor = 'var(--error-color)';
        const warningColor = 'var(--warning-color)';
        const normalColor = undefined;//'var(--normal-color)';

        if (dueDate < currentDate)
            return errorColor;
        // if (calculateDaysDifference(dueDate, currentDate) === 0) {
        //     return warningColor;
        // }

        return normalColor;
    }

    const [sortConfig, setSortConfig] = useState({key: 'deliveryDate', direction: 'ascending'});

    const [sortedSales, setSortedSales] = useState([]);

    useEffect(() => {
        setSortedSales([...sales].sort((a, b) => {
            const aValue = getSortValue(a, sortConfig.key);
            const bValue = getSortValue(b, sortConfig.key);

            if (aValue < bValue) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        }));
    }, [sales, sortConfig]);
    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({key, direction});
    };

    const getSortIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? '▲' : '▼';
        }
        return '';
    };

    async function handleStatus(index, status) {
        const response = await updateSaleStatus(sortedSales[index].id, status);
        if (response > 0) {
            setSortedSales((prevItems) =>
                prevItems.map((item, i) => {
                        return i === index ? {
                            ...item,
                            status: status,
                        } : item;
                    }
                )
            );
        } else {
            showAlert('O status não foi atualizado em nenhum serviço.');
        }
    }

    function paidValue(sale) {
        return (sale.receivables || [])
            .filter(receivable => receivable.status === 1)
            .reduce((sum, receivable) => sum + receivable.value, 0);
    }

    // Uma forma de pagamento: valor e forma na mesma linha. Mais de uma: uma linha por forma abaixo do rótulo.
    function renderPrintPaymentLines(label, total, receivables) {
        const formatValue = (value) => value.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        const groups = [];
        receivables.forEach((receivable) => {
            const name = receivable.paymentMethod?.name || 'SEM FORMA';
            const group = groups.find((g) => g.name === name);
            if (group) {
                group.value += receivable.value;
            } else {
                groups.push({name, value: receivable.value});
            }
        });

        if (groups.length <= 1) {
            return (
                <div style={{marginBottom: '5px'}}>
                    {label}: R$ {formatValue(groups.length === 1 ? groups[0].value : total)}
                    {groups.length === 1 && ` - ${groups[0].name.toUpperCase()}`}
                </div>
            );
        }

        return (
            <div style={{marginBottom: '5px'}}>
                <div>{label}:</div>
                {groups.map((group) => (
                    <div key={group.name}>R$ {formatValue(group.value)} - {group.name.toUpperCase()}</div>
                ))}
            </div>
        );
    }

    function printSale(saleIndex) {
        setSaleShowPrintDialogIndex(saleIndex);
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: '',
        pageStyle: `
    @media print {
        * {
            font-size: 12px !important;
            color: black !important;
        }
    }
    `,
    });


    const handleInputChange = (e) => {
        const string = e.target.value;
        setSearchTerm(string);
    };

    const buildSaleRowActions = (sale, index) => {
        const saleFiles = sale.files || [];
        const actions = [];

        if (sale.customerPhone) {
            actions.push({
                key: 'whatsapp',
                label: 'WhatsApp',
                phoneNumber: sale.customerPhone,
                personName: sale.customerName,
                message: buildDefaultWhatsAppMessage(sale.customerName),
                render: () => (
                    <WhatsAppButton
                        phoneNumber={sale.customerPhone}
                        personName={sale.customerName}
                    />
                ),
            });
        }

        actions.push({
            key: 'view',
            label: 'Ver Serviço',
            onClick: () => setSaleIdToBeShowed(sale.id),
        });

        actions.push({
            key: 'print',
            label: 'Imprimir',
            onClick: () => printSale(index),
        });

        actions.push({
            key: 'file',
            label: 'Arquivo',
            disabled: saleFiles.length === 0,
            onClick: async () => {
                if (saleFiles.length > 1) {
                    setSaleShowFilesToDownload(sale);
                } else if (saleFiles.length === 1) {
                    await downloadSaleFile(sale.id, saleFiles[0].displayFileName);
                }
            },
        });

        if (hasUserPermission(UserPermission.EDIT_SERVICE)) {
            actions.push({
                key: 'edit',
                label: 'Editar',
                type: 'edit',
                onClick: () => navigate('/app/sale?id=' + sale.id),
            });
        }

        if (hasUserPermission(UserPermission.REMOVE_SERVICE)) {
            actions.push({
                key: 'delete',
                label: 'Excluir',
                type: 'delete',
                onClick: async () => {
                    if (await showConfirm('Deseja realmente excluir?')) {
                        await removeSale(sale.id);
                    }
                },
                buttonProps: {className: 'remove-button'},
            });
        }

        return actions;
    };

    if (loadingPermissions) {
        return <Loading></Loading>;
    }
    if (hasUserPermission(UserPermission.LIST_SERVICE) === false) {
        navigate('/unauthorizedaccess');
    }

    const disabledStatus = [SaleStatus.CONCLUDED, SaleStatus.CANCELED];
    if(hasCompanyPermission(CompanyPermission.DISABLE_SENDING_FILE_SERVICE_LIST)) {
        disabledStatus.push(SaleStatus.SENDING_THE_FILE);
    }
    return (
        <>
            {saleIdToBeShowed && <ModalDiv closeModal={() => setSaleIdToBeShowed(undefined)}>

                <SaleViewer saleId={saleIdToBeShowed}>
                </SaleViewer>
            </ModalDiv>}
            {saleShowPrintDialogIndex >= 0 && (
                <ModalDiv closeModal={() => setSaleShowPrintDialogIndex(undefined)} style_={{width: '400px'}}>
                    <div ref={componentRef}>
                        <div style={{marginLeft: '5mm', color: 'black', fontSize: '12px'}}>
                            <div
                                style={{marginBottom: '5px'}}>CÓDIGO: {sortedSales[saleShowPrintDialogIndex].code}</div>
                            <div
                                style={{marginBottom: '5px'}}>CLIENTE: {sortedSales[saleShowPrintDialogIndex].customerName}</div>
                            <div
                                style={{marginBottom: '5px'}}>CONTATO: {sortedSales[saleShowPrintDialogIndex].customerPhone}</div>
                            <div
                                style={{marginBottom: '5px'}}>COLABORADOR: {sortedSales[saleShowPrintDialogIndex].user?.name ?? '-'}</div>
                            <div
                                style={{marginBottom: '5px'}}>PEDIDO: {formatDateToString(new Date(sortedSales[saleShowPrintDialogIndex].saleDate))}</div>
                            <div
                                style={{marginBottom: '5px'}}>ENTREGA: {formatDateTimeToString(new Date(sortedSales[saleShowPrintDialogIndex].deliveryDate))}</div>
                            <div style={{marginBottom: '5px'}}>VALOR:
                                R$ {sortedSales[saleShowPrintDialogIndex].totalValue.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}</div>
                            {renderPrintPaymentLines('PAGO', paidValue(sortedSales[saleShowPrintDialogIndex]),
                                (sortedSales[saleShowPrintDialogIndex].receivables || []).filter(receivable => receivable.status === 1))}

                            {renderPrintPaymentLines('RESTANTE',
                                sortedSales[saleShowPrintDialogIndex].totalValue - paidValue(sortedSales[saleShowPrintDialogIndex]),
                                (sortedSales[saleShowPrintDialogIndex].receivables || []).filter(receivable => receivable.status !== 1))}
                        </div>
                    </div>
                    <ActionButtonsManagerView>
                        <button onClick={async () => {
                            await handlePrint();
                        }}>Imprimir
                        </button>
                        <ConfirmButton title="Concluir" onClick={async () => {
                            await handleStatus(saleShowPrintDialogIndex, SaleStatus.CONCLUDED);
                            setSaleShowPrintDialogIndex(undefined);
                        }}/>
                    </ActionButtonsManagerView>
                </ModalDiv>
            )}
            {saleShowFilesToDownload && (
                <ModalDiv closeModal={() => setSaleShowFilesToDownload(undefined)} style_={{width: '570px'}}>
                    <div>Arquivos</div>
                    <ul style={{display: 'flex', flexDirection: 'column', padding: 0}}>
                        {(saleShowFilesToDownload.files || []).map((file, index) => (
                            <li key={index}
                                style={{display: 'flex', alignItems: 'center', marginBottom: '8px', listStyle: 'none'}}>
                                <a href="" style={{cursor: "pointer"}} onClick={async (e) => {
                                    e.preventDefault();
                                    await downloadSaleFile(saleShowFilesToDownload.id, file.displayFileName);
                                }}>
                                    {file.displayFileName}
                                </a>

                            </li>
                        ))
                        }
                    </ul>
                </ModalDiv>
            )}
            <ListPageLayout
                tableWidth={900}
                header={
                    <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                        <div className="header-label">Consulta de Serviços</div>
                        {hasUserPermission(UserPermission.CREATE_SERVICE) &&
                            <NewButton onClick={() => navigate('/app/sale')}/>
                        }
                    </div>
                }
                filters={
                    <div className="list-page-filters-sale">
                <div className="list-page-filters-sale-fields">
                    <div className="list-page-filters-field list-page-filters-query">
                        <div className="list-page-filters-sale-label">Código/Nome/Telefone</div>
                        <input
                            type="text"
                            className="list-page-filters-query-input"
                            value={searchTerm}
                            onChange={handleInputChange}
                            data-test="search-input"
                        />
                    </div>
                    <div className="list-page-filters-field">
                        <div className="list-page-filters-sale-label">Data de Entrega</div>
                        <div className="list-page-filters-period">
                            <DatePicker
                                className="datepicker"
                                selected={startDate}
                                onChange={handleStartDateChange}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                            />
                            <span className="list-page-filters-period-separator">até</span>
                            <DatePicker
                                className="datepicker"
                                selected={endDate}
                                onChange={handleEndDateChange}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="list-page-filters-sale-selects">
                        <div className="list-page-filters-field" ref={sectorDropdownRef} style={{position: 'relative'}}>
                            <div className="list-page-filters-sale-label">Setor</div>
                            <button
                                type="button"
                                onClick={() => setSectorDropdownOpen(o => !o)}
                                style={{
                                    width: '100%', textAlign: 'left',
                                    fontFamily: 'Arial, sans-serif', padding: '7px', margin: '0 2px',
                                    border: '1px solid var(--color-input-border)', borderRadius: '5px',
                                    minHeight: '29px', boxSizing: 'border-box', cursor: 'pointer',
                                    background: 'var(--color-bg-elevated)', color: 'var(--color-text-primary)',
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                                }}
                            >
                                <span style={{textTransform: 'uppercase'}}>{sectorLabel}</span>
                                <span style={{fontSize: '10px', marginLeft: '6px'}}>▼</span>
                            </button>
                            {sectorDropdownOpen && (
                                <div style={{
                                    position: 'absolute', top: '100%', left: 0, zIndex: 999,
                                    background: 'var(--color-bg-elevated)', border: '1px solid var(--color-border)',
                                    borderRadius: '4px', minWidth: '160px', maxHeight: '220px',
                                    overflowY: 'auto', boxShadow: '0 4px 12px var(--color-modal-shadow)'
                                }}>
                                    <label style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 10px', cursor: 'pointer', textTransform: 'uppercase'}}>
                                        <input
                                            type="checkbox"
                                            checked={allSectorsSelected}
                                            onChange={() => allSectorsSelected ? setSelectedSectorIds([]) : setSelectedSectorIds(sectors.map(s => s.id))}
                                        />
                                        Todos
                                    </label>
                                    {sectors.map(sector => (
                                        <label key={sector.id} style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 10px', cursor: 'pointer', textTransform: 'uppercase'}}>
                                            <input
                                                type="checkbox"
                                                checked={selectedSectorIds.includes(sector.id)}
                                                onChange={() => toggleSectorId(sector.id)}
                                            />
                                            {sector.name}
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="list-page-filters-field">
                            <div className="list-page-filters-sale-label">Status</div>
                            <select value={status} onChange={(e) => setStatus(e.target.value)}>
                                <option key="ALL" value="ALL">
                                    {statusTranslate.ALL.label}
                                </option>
                                <option key="IN_PROGRESS" value="IN_PROGRESS">
                                    {statusTranslate.IN_PROGRESS.label}
                                </option>
                                {renderSaleOptions()}
                            </select>
                        </div>
                        <div className="list-page-filters-sale-query list-page-filters-sale-query--desktop">
                            <SearchButton title="Consultar" onClick={handleQuery}/>
                        </div>
                    </div>
                    <div className="list-page-filters-sale-query list-page-filters-sale-query--mobile">
                        <SearchButton title="Consultar" onClick={handleQuery}/>
                    </div>

                </div>
                    </div>
                }
                footer={hasUserPermission(UserPermission.SHOW_TOTAL_SALE_LIST) ? (
                    <>
                        <div className="total-label">Quantidade: {sales.length}</div>
                        <div className="total-label">Valor Total: R$ {totalValue.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}</div>
                    </>
                ) : null}
            >
            <div className="list-page-sales">
            <table>
                <thead>
                <tr>
                    <th className="sale-col--optional" style={{textAlign: 'center', cursor: "pointer", minWidth: "70px"}}
                        onClick={() => handleSort('code')}>
                        {getSortIcon('code')} Código
                    </th>
                    <th className="sale-col--essential sale-col--customer" style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('customerName')}>
                        {getSortIcon('customerName')} Cliente
                    </th>
                    <th className="sale-col--optional" style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('user.name')}>
                        {getSortIcon('user.name')} Vendedor
                    </th>
                    <th className="sale-col--optional" style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('sector.name')}>
                        {getSortIcon('sector.name')} Setor
                    </th>
                    <th className="sale-col--optional" style={{textAlign: 'center', cursor: "pointer", minWidth: "100px"}}
                        onClick={() => handleSort('saleDate')}>
                        {getSortIcon('saleDate')} Data
                    </th>
                    <th className="sale-col--essential sale-col--value" style={{cursor: "pointer", minWidth: "70px", textAlign: 'right'}}
                        onClick={() => handleSort('totalValue')}>
                        {getSortIcon('totalValue')} Valor
                    </th>
                    <th className="sale-col--essential sale-col--status" style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('status')}>
                        {getSortIcon('status')} Status
                    </th>
                    <th className="sale-col--essential sale-col--delivery" style={{textAlign: 'center', cursor: "pointer", minWidth: "100px"}}
                        onClick={() => handleSort('deliveryDate')}>
                        {getSortIcon('deliveryDate')} Entrega
                    </th>
                    <th className="sale-col--actions"/>
                </tr>
                </thead>
                <tbody style={{overflowY: 'auto'}}>
                {sortedSales.map((sale, index) => {
                    const saleStatusStyle = getSaleStatusStyle(sale.status);
                    const saleFiles = sale.files || [];

                    return (
                    <tr key={sale.id ?? index} style={{backgroundColor: sale.sector?.color ?? undefined}}>
                        <td className="sale-col--optional">
                            <div style={{textAlign: 'center'}}>{sale.code}</div>
                        </td>
                        <td className="sale-col--essential sale-col--customer">
                            <div>{sale.customerName}</div>
                        </td>
                        <td className="sale-col--optional">
                            <div>{sale.user?.name ?? '-'}</div>
                        </td>
                        <td className="sale-col--optional">
                            <div>{sale.sector?.name ?? '-'}</div>
                        </td>
                        <td className="sale-col--optional">
                            <div style={{textAlign: 'center'}}>{formatDateToString(new Date(sale.saleDate))}</div>
                        </td>
                        <td className="sale-col--essential sale-col--value">
                            <div style={{textAlign: 'right'}}>{sale.totalValue.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</div>
                        </td>
                        <td className="sale-col--essential sale-col--status">
                            <div style={{
                                display: "flex",
                                backgroundColor: saleStatusStyle.color,
                                borderRadius: '3px',
                                borderColor: saleStatusStyle.color,
                                justifyContent: 'center'
                            }}
                            >
                                <select
                                    style={{
                                        padding: '2px',
                                        backgroundColor: saleStatusStyle.color,
                                        borderColor: saleStatusStyle.color
                                    }}
                                    value={sale.status} onChange={(e) => {
                                    // eslint-disable-next-line no-restricted-globals
                                    if (!confirm(`Deseja realmente mudar o status do serviço ${sale.code} de '${saleStatusStyle.label}' para '${getSaleStatusStyle(e.target.value).label}'?`)) {
                                        return;
                                    }
                                    if (e.target.value === SaleStatus.CONCLUDED) {
                                        showAlert('É necessário imprimir antes de concluir o serviço!');
                                        printSale(index);
                                        return;
                                    }
                                    handleStatus(index, e.target.value)
                                }}>
                                    {renderSaleOptions(disabledStatus)}
                                </select>

                            </div>
                        </td>
                        <td className="sale-col--essential sale-col--delivery">
                            <div style={{
                                backgroundColor: getWarningDeliveryDateColor(sale),
                                padding: '3px',
                                borderRadius: '3px',
                                textAlign: 'center'
                            }}>{formatDateTimeNoSecondsToString(new Date(sale.deliveryDate))}</div>
                        </td>
                        <td className="sale-col--actions table-actions">
                            <TableRowActions actions={buildSaleRowActions(sale, index)}/>
                        </td>

                    </tr>
                    );
                })}
                </tbody>
                {sales.length === 0 && (
                    <tfoot>
                    <tr>
                        <td colSpan={9}>{loading ? 'Carregando...' : 'Nenhum item encontrado.'}</td>
                    </tr>
                    </tfoot>
                )}
            </table>
            </div>
            </ListPageLayout>

        </>
    );
};

export default SaleList;
